import { render, staticRenderFns } from "./tan_car_img.vue?vue&type=template&id=deef79c8&scoped=true"
import script from "./tan_car_img.vue?vue&type=script&lang=js"
export * from "./tan_car_img.vue?vue&type=script&lang=js"
import style0 from "./tan_car_img.vue?vue&type=style&index=0&id=deef79c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deef79c8",
  null
  
)

export default component.exports